module.exports = __webpack_public_path__ + "img/top2.e37ea0c4.png";